import React, { useState, useContext } from "react";
import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography, 
  MenuItem,
  IconButton,
  Menu
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu"; 
import AccountCircle from "@material-ui/icons/AccountCircle";

import MainListItems from "./MainListItems";
import NotificationsPopOver from "../components/NotificationsPopOver";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    minHeight: "48px",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#efbc00",
  },
  menuButton: {
    color: "#ffffff",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  appBarSpacer: {
    minHeight: "48px",
  },
  content: {
    flex: 1,
    overflow: "auto",
    padding: '10px 10px 10px 10px'
  },
  switch: {
    transform: "scale(0.8)",
  },
  iconButton: {
    color: "#ffffff",
  },
  themeSwitchContainer: {
    display: "flex",
    alignItems: "center",
  },
  themeIcon2: {
    color: "#000000",
  },
}));

const LoggedInLayout = ({ children }) => {
  const classes = useStyles();
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { handleLogout, loading, user } = useContext(AuthContext);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };0

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const handleClickSomAtivarDesativarSomNotificacoes = () => {
    const somAtivo = localStorage.getItem("somNotificacoesAtivo") === "true";
    localStorage.setItem("somNotificacoesAtivo", !somAtivo);
    window.location.reload();
  }

  const somAtivo = localStorage.getItem("somNotificacoesAtivo") === "true";

  const drawerClose = () => {
    setDrawerOpen(false);
  };

  if (loading) {
    return <BackdropLoading />;
  }

  return (
    <div className={classes.root}>
      {/* Drawer SOBREPOSTO */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={drawerClose}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <List dense>
          <MainListItems drawerClose={drawerClose} />
        </List>
      </Drawer>

      <UserModal
        open={userModalOpen}
        onClose={() => setUserModalOpen(false)}
        userId={user?.id}
      />

      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar variant="dense" className={classes.toolbar}>
          <IconButton
            edge="start"
            aria-label="open drawer"
            onClick={() => setDrawerOpen(true)}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>

          <Typography
            component="h1"
            variant="h6"
            noWrap
            className={classes.title}
          >
            <img
              width="80px"
              src="https://www.nrwork.com.br/conteudo/imagem/e6e5a5768ebb1387fbae633f0b6e3a5b_g.png"
              alt="NRWork Logo"
            />
          </Typography>

          {user?.id && (
            <NotificationsPopOver className={classes.iconButton} />
          )}

          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              className={classes.iconButton}
            >
              <AccountCircle />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleCloseMenu}
            > 
              <MenuItem onClick={handleOpenUserModal}>
                {i18n.t("mainDrawer.appBar.user.profile")}
              </MenuItem>

              <MenuItem onClick={handleClickLogout}>
                {i18n.t("mainDrawer.appBar.user.logout")}
              </MenuItem>

              <MenuItem onClick={handleClickSomAtivarDesativarSomNotificacoes}>
                {somAtivo ? i18n.t("mainDrawer.appBar.user.som_desativar") : i18n.t("mainDrawer.appBar.user.som_ativar")}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {children}
      </main>
    </div>
  );
};

export default LoggedInLayout;
